import log from 'loglevel';
import { ApiService } from './ApiService';
import { useDeviceParams } from '@/composables/device.config';
import { LoginResponse } from '@/interfaces/Auth/LoginResponse';
import { NoTokenStrategy } from '../strategies/NoTokenStrategy';
import { SignupResponse } from '@/interfaces/Auth/SignupResponse';
import { ErrorResponse } from '@/interfaces/ErrorResponse';

class AuthServiceClass extends ApiService {



	private LOGIN_ENDPOINT = '/authorize';
	private REGISTER_ENDPOINT = '/register';
	private deviceParams = useDeviceParams();

	constructor() {
		super(NoTokenStrategy)
	}




	private async sendLoginRequest(provider: 'google' | 'facebook', token: string): Promise<LoginResponse> {
		const data = new FormData();
		data.append('via', provider);
		data.append('token', token);
		data.append('web_device', JSON.stringify(this.deviceParams.deviceParams.value));

		try {
			return await this.post(this.LOGIN_ENDPOINT, data);
		} catch (error) {
			log.error(`Failed to login with ${provider}:`, error);
			throw error;
		}
	}




	async loginWithGoogle(token: string): Promise<LoginResponse> {
		return this.sendLoginRequest('google', token);
	}




	async loginWithFacebook(accessToken: string): Promise<LoginResponse> {
		return this.sendLoginRequest('facebook', accessToken);
	}





	async signup(firstName: string, lastName: string, email: string, password: string, captcha: string): Promise<SignupResponse> {
		const data = new FormData();
		data.append('email', email);
		data.append('password', password);
		data.append('first_name', firstName);
		data.append('last_name', lastName);
		data.append('captcha', captcha);
		data.append('web_device', JSON.stringify(this.deviceParams.deviceParams.value));
		data.append('fromBrowser', 'true');
		try {
			const response: SignupResponse = await this.post(this.REGISTER_ENDPOINT, data);
			return response;
		} catch (error: ErrorResponse | any) {
			log.error('Failed to send signup request:', error);
			throw error.response?.data?.error || error;
		}
	}





	async emailSignin(email: string, password: string): Promise<LoginResponse> {
		const data = new FormData();
		data.append('email', email);
		data.append('password', password);
		data.append('via', 'email');
		data.append('web_device', JSON.stringify(this.deviceParams.deviceParams.value));
		data.append('fromBrowser', 'true');
		try {
			const response: LoginResponse = await this.post(this.LOGIN_ENDPOINT, data);
			return response;
		} catch (error: ErrorResponse | any) {
			log.error('Failed to send email signin request:', error);
			throw error.response?.data?.error || error;
		}
	}


}

const AuthService = new AuthServiceClass();
export { AuthService };
